/**
 * IndexedDBマネージャー共通の型定義
 */

export interface CustomValue {
  id: string
  type: 'style' | 'motif' | 'subcategory' | 'nameType' | 'category' | 'era' | 'sceneType' | 'genre' | 'atmosphere' | 'writingStyle' | 'communityType' | 'locationType' | 'purpose'
  generatorType?: 'name' | 'title' | 'character' | 'wikipedia' | 'scene' | 'plot' | 'community' | 'location' // どのジェネレータ用か
  nameType?: string // サブカテゴリ用の名前タイプ
  value: string
  label: string
  createdAt: Date
  usageCount: number
  lastUsedAt?: Date
}

export interface StoredProject {
  id: string
  name: string
  description?: string
  data: any
  createdAt: Date
  updatedAt: Date
}

export interface ApiKey {
  id: string
  name: string
  key: string
  provider?: AIProviderId
  isActive: boolean
  usageCount: number
  lastUsedAt?: Date
  rateLimitedUntil?: Date
  createdAt: Date
}

export function getApiKeyProvider(apiKey: ApiKey): AIProviderId {
  return apiKey.provider ?? 'gemini'
}

export interface SavedImagePrompt {
  id: string
  title: string
  input: any // ImagePromptInput type from @creanizer/types
  result: any // ImagePromptResult type from @creanizer/types
  createdAt: string
  updatedAt: string
  memo?: string
  tags?: string[]
}

export interface BaseManager {
  db: IDBDatabase | null
}
import type { AIProviderId } from '@creanizer/types'
